export class DeckBuilderViewStates {
  static DecksList = 0;
  static DeckEdit = 1;
  static CardsList = 2;
  static AdvancedSearchCard = 3;
}